import { Link } from "react-router-dom";

export const Logo = ({ className = "" }) => (
  <Link
    to="/"
    data-testid="nav-logo"
    className={`flex items-center gap-2 group ${className}`}
  >
    <span className="inline-flex h-9 w-9 items-center justify-center border border-gold/60 text-gold font-serif text-xl leading-none">
      M
    </span>
    <span className="font-serif text-2xl tracking-wide text-offwhite">
      Med<span className="text-gold">Prime</span>
    </span>
  </Link>
);
